import { useDeleteLogicoUsuario } from "@/hooks/useDeleteLogicoUsuario";
import type { ClienteIntermedio } from "@/interfaces/user.interface";
import { AccionesGenericas } from "./AccionesGenericas";
import { EditClienteIntermedioForm } from "../forms/clientes-intermedios/EditClienteIntermedioForm";
import { DetalleClienteIntermedio } from "../dashboards/superAdmin/modales/ModalDetalleClienteIntermedio";

type AccionesClienteIntermedioCellProps = {
  cliente: ClienteIntermedio;
  queryKey?: ReadonlyArray<unknown>;
};

export default function AccionesClienteIntermedioCell({
  cliente,
  queryKey = ["clientesIntermedios"],
}: AccionesClienteIntermedioCellProps) {
  const { mutate } = useDeleteLogicoUsuario({
    queryKey,
  });
  return (
    <AccionesGenericas
      data={cliente}
      id={cliente.idUsuario}
      label="Cliente Intermedio"
      queryKey={queryKey}
      FormularioEdicion={EditClienteIntermedioForm}
      onDelete={(id) => mutate(id)}
      DetalleContenido={DetalleClienteIntermedio}
    />
  );
}
